import React from 'react';
import ReactDOM from 'react-dom/client';
import './globals.css';
import ProtectedApp from './components/protectedApp';
import reportWebVitals from './reportWebVitals';
import AuthContextProvider from './context/AuthContextProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <AuthContextProvider>
    <React.StrictMode>
      <ProtectedApp />
    </React.StrictMode>
  </AuthContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
